import { createUpsell } from '../upsell';
export const eNbZ8o = createUpsell({
    id: 'eNbZ8o',
    desc: 'All-in-One upsell — Lifetime first, 1-Year shown only on decline — White Design',
    seq: [
        {
            id: 'upsell-all-in-one-lifetime-white',
            onDecline: ['upsell-all-in-one-1-year-white'],
        },
    ],
});
